import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=64787fe8&scoped=true"
import script from "./Reports.js?vue&type=script&lang=js&external"
export * from "./Reports.js?vue&type=script&lang=js&external"
import style0 from "./Reports.vue?vue&type=style&index=0&id=64787fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64787fe8",
  null
  
)

export default component.exports